const RedChecklist = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.83461 13.2118L14.4372 7.60928L13.559 6.7311L8.83461 11.4555L6.45961 9.08045L5.58143 9.95864L8.83461 13.2118ZM2.91797 17.0836V2.91699H17.0846V17.0836H2.91797Z"
        fill="#CE181E"
      />
    </svg>
  );
};

export default RedChecklist;
